// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const FoodFolate = {
  productCode: "SBOVZ-B9TFF",
  productName: "Food Folate",
  ingredients: "Spinacia oleracea ",
  overview:"Food Folate is a hydrolyzed extract blend of Organic Spinach carefully harvested and processed after CQL screening to tap all bio-available folates forms making the product consistent and rich with polyglutamates. ",
  assay:"Natural Food Folate 2 % ",
  coNutrients:"Incidental nutrients include omega 3 fatty acids, Iron, Vitamin A & K (not a claim). Spinach is also an excellent source of vitamin C and folic acid as well as being a good source of manganese, magnesium and vitamin B2.",
  studies:"Comprehensive Stability studies, On-going studies to understand Folate supplement intakes influences on biological processes related to the neural tube.",
  benefits:"Besides Folate value, Spinach is rich in bio-flavonoids which help reduce imbalance between prooxidants and antioxidants, imbalance is an indication associated with risk of oxidative stress-induced disease. Spinach contains water-soluble natural antioxidants which will work in an effective way to ameliorate high fat and cholesterol diet-induced oxidative stress. They reduce liver TBARS levels by inhibiting the oxidation of LDL, protects leukocytes from oxidative stress, alleviates oxidative stress through the modulation of antioxidant metabolism, resulting in a protective effect against HFCD-induced DNA damage, protects membrane lipids from damage resulting from exposure to ROS. Antioxidant activity of Glucurinated flavonoid from spinach protects against ROS formation in fibroblasts. ",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/FoodFolate/FF-1.png",
    "images/Portfolio/OrgavitazForDeficiencies/FoodFolate/FF-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/FoodFolate/FF-3.png",
    "images/Portfolio/OrgavitazForDeficiencies/FoodFolate/FF-4.png",



  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default FoodFolate;
